import { render, staticRenderFns } from "./AssignRole.vue?vue&type=template&id=c32263c6&"
import script from "./AssignRole.vue?vue&type=script&lang=js&"
export * from "./AssignRole.vue?vue&type=script&lang=js&"
import style0 from "./AssignRole.vue?vue&type=style&index=0&id=c32263c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports